export const API_ROUTES = {
  AUTH: {
    PROFILE: '/auth/profile',
    LOGIN: '/auth/login',
    SIGN_UP: '/auth/register',
    INVITE_REGISTER: '/auth/register/invitation',
    CHECK_CODE: '/auth/check-registration-code',
    SEND_CODE: '/auth/2fa-code',
    CONFIRM_CODE: '/auth/2fa-confirm',
    LOGIN_CONFIRM: '/auth/2fa-confirm-login',
    FORGOT_PASSWORD: '/auth/send-reset-password-email',
    RESET_PASSWORD: '/auth/reset-password',
    CONFIRM_UPDATE_EMAIL: '/user/accept-update-email'
  },
  DASHBOARD: {
    ROOT: '/dashboard',
    VERSION: '/dashboard/version',
    VERSIONS: '/dashboard/byVersion',
    IMAGE: '/dashboard/image',
    RECOMMENDATION: '/dashboard/recommendation',
    DELETE: '/dashboard/versions'
  },
  BRAND: {
    ROOT: '/brand',
    GROUP: '/brand/group'
  },
  STAGE: {
    ROOT: '/stage'
  },
  TYPE: {
    ROOT: '/type'
  },
  TERRITORIES: {
    ROOT: '/location/territory',
    LOCATIONS: '/location/byTerritory'
  },
  MATERIALS: {
    GROUPS: '/material/group',
    LISTS: '/material/byGroup'
  },
  COMPANY: {
    ROOT: '/company'
  },
  USERS: {
    ROOT: '/user',
    INVITE: '/user/invite'
  }
};
